import {
  Configuration,
  UserAuthApi,
  InvitationApi,
  UserApi,
  MailTrapApi
} from '../../auth';
import { IAccount } from '../../models';
import { getBaseConfiguration } from '../api';

export { RequiredError } from '../../auth/base';

export const authBasePath = process.env.AUTH_API_URL;

export const getAdminAuthApi = (token?: string) => {
  const configuration = new Configuration();
  configuration.basePath = authBasePath;
  if (token) {
    configuration.apiKey = token;
  }
  return new UserAuthApi(configuration);
};

export const getUserApi = (account: IAccount): UserApi => {
  return new UserApi(getBaseConfiguration(account, authBasePath));
};

export const getMailTrapApi = (account): MailTrapApi => {
  return new MailTrapApi(getBaseConfiguration(account, authBasePath));
};

export const getInvitationApi = (account): InvitationApi => {
  return new InvitationApi(getBaseConfiguration(account, authBasePath));
};
